<div class="wizard-step">
    <h2 class="step-title">Paso 4: Beneficios</h2>
    <p class="step-description">
        Describe los beneficios clave que obtendrán tus clientes. Estos se mostrarán como una lista en la página del
        producto.
    </p>

    @if(!isReadonly) {
    <div class="recommendation compact">
        <div class="recommendation-icon">⚠️</div>
        <div class="recommendation-content">
            <h4 class="recommendation-title">Requisito</h4>
            <p class="recommendation-text">
                Debes completar al menos {{requiredBenefits}} beneficios. Puedes agregar más si lo deseas.
            </p>
        </div>
    </div>
    }

    @if(!isReadonly) {
    <div class="benefits-list">
        <div class="benefit-item compact" *ngFor="let b of benefits; let i = index">
            <div class="benefit-handle v-center">
                <button class="btn-ghost sm" (click)="moveUp(i)" [disabled]="i===0">▲</button>
                <button class="btn-ghost sm" (click)="moveDown(i)" [disabled]="i===benefits.length-1">▼</button>
            </div>

            <div class="benefit-content">
                <div class="benefit-row compact">
                    <div class="benefit-field">
                        <label class="field-label">Texto corto</label>
                        <input type="text" [(ngModel)]="b.shortText" placeholder="Escribe el beneficio"
                            class="field-input sm" (input)="onChange()" />
                    </div>

                    <div class="benefit-field icon-field">
                        <label class="field-label">Icono</label>
                        <div class="icon-input">
                            <span class="fa-preview sm">
                                <i [class]="b.iconName || 'fas fa-check-circle'"></i>
                            </span>
                            <app-icon-picker [value]="b.iconName" (valueChange)="onIconPicked(i, $event)"
                                [options]="iconOptionsMapped" [pageSize]="20">
                            </app-icon-picker>
                        </div>
                        <small class="hint">
                            Usa clases de Font Awesome (ej: <b>fas fa-star</b>).
                        </small>
                    </div>


                </div>
            </div>

            <button type="button" class="delete-benefit sm v-center" title="Eliminar" (click)="removeBenefit(i)"
                *ngIf="benefits.length > 1">
                <i class="fas fa-trash"></i>
            </button>
        </div>
    </div>

    <button type="button" class="add-benefit-btn sm mt-2" (click)="addBenefit()">
        <i class="fas fa-plus"></i>
        Agregar beneficio
    </button>

    <div class="validation-hint mt-2">
        <p *ngIf="completedBenefitsCount < requiredBenefits" class="invalid-field">
            Debes completar al menos {{requiredBenefits}} beneficios con texto corto e icono.
        </p>
    </div>
    }

    @if(isReadonly) {
    <ul class="readonly-benefits list-unstyled mt-3">
        <li *ngFor="let b of benefits" class="readonly-benefit-item">
            <i [class]="b.iconName || 'fas fa-check-circle'" class="me-2"></i>
            {{ b.shortText }}
        </li>
    </ul>
    }
</div>